import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("删除选中")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_table_wrapper = _resolveComponent("table-wrapper")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { size: "small" }, {
    title: _withCtx(() => [
      _createTextVNode("待选列表 - " + _toDisplayString(_ctx.value.length) + "项", 1)
    ]),
    extra: _withCtx(() => [
      _createVNode(_component_a_button, {
        size: "small",
        type: "link",
        onClick: _ctx.remove
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_table_wrapper, {
        "row-key": "id",
        size: "small",
        bordered: true,
        "data-source": _ctx.value,
        columns: _ctx.columns,
        onOnSelectionChange: _ctx.onSelectionChange,
        onChange: _ctx.onTableChange,
        tableHeight: _ctx.tableHeight-20
      }, null, 8, ["data-source", "columns", "onOnSelectionChange", "onChange", "tableHeight"])
    ]),
    _: 1
  }))
}